import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import supportedIconMap from './supportedIcons';
import styles from './styles.scss';

const HomeIcon = ({ size, name, color, spacing, fallbackImage }) => {
  if (supportedIconMap[name]) {
    return <Icon size={size} color={color} spacing={spacing} component={supportedIconMap[name]} />;
  }

  if (fallbackImage) {
    return (
      <span className={classnames(styles.fallbackWrapper)}>
        <Spacer spacing={spacing}>
          <div
            className={classnames(styles.fallbackImage, {
              [styles.size18]: size === 18,
              [styles.size36]: size === 36,
              [styles.size48]: size === 48,
            })}
          >
            <BackgroundImage src={fallbackImage} />
          </div>
        </Spacer>
      </span>
    );
  }

  return null;
};

HomeIcon.propTypes = {
  /**
   * An image url to render a hosted image version of the icon as a fallback for when
   * an icon name isn't supported.
   */
  fallbackImage: PropTypes.string,
  name: PropTypes.string,
  size: Icon.propTypes.size,
  color: Icon.propTypes.color,
  spacing: Icon.propTypes.spacing,
};

HomeIcon.defaultProps = {
  ...Icon.defaultProps,
  fallbackImage: undefined,
  name: '',
};

export default HomeIcon;
